import { styled, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)(
  ({ colorIndicator }: { colorIndicator: string }) => ({
    '& .MuiTabs-indicator': {
      backgroundColor: colorIndicator,
    },
  })
);
